import React from "react";
import AllCampaigns from "../component/sections/campaigns/AllCampaigns";
import ViewCampaign from "../component/sections/campaigns/ViewCampaign";

const campaignsRoutes = [
  {
    path: "/campaigns/all",
    render: () => <AllCampaigns />,
    exact: true,
  },
  {
    path: "/campaigns/:id",
    render: () => <ViewCampaign />,
    exact: true,
  },
];

export default campaignsRoutes;
